import { AppLogoType } from '@thoughtspot/custom-style-service';
import { useTranslation } from '@thoughtspot/i18n';
import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
import { getOnEnter } from '@thoughtspot/radiant-react/widgets/_utils/index';
import { Image } from '@thoughtspot/radiant-react/widgets/image';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import { RoutedLink } from '@thoughtspot/radiant-react/widgets/link';
import React, { useLayoutEffect, useRef } from 'react';
import { handleClick } from "../utils/nav-config.util";
import { useBlinkContextForGlobalNav, useValidateBlinkContextForGlobalNav, } from '../contexts/global-nav-blink-context';
import { ApplicationSwitcher, } from './application-switcher/application-switcher';
import { HelpMenuContainer } from './help-menu/help-menu.container';
import { OrgMenuContainer } from './org-menu/org-menu.container';
import styles from './top-nav.module.scss';
export var TopNavTestIDs;
(function (TopNavTestIDs) {
    TopNavTestIDs["HomeLink"] = "home-link";
})(TopNavTestIDs || (TopNavTestIDs = {}));
const AppLogoDefault = '/resources/img/logo/TS-logo-white-no-bg.svg';
export const TopNav = ({ homeButtonConfig, applicationSwitcherConfig, searchBar, userProfile, activeApplicationID, shouldShowPendoHelp, disableQuickLinks = false, isEmbedded = false, customQuickLinks = [], learningModule, invalidateSessionInfoCallCache, }) => {
    useValidateBlinkContextForGlobalNav();
    const { t } = useTranslation();
    const { sessionService, metricsService, customStylingService, navService, } = useBlinkContextForGlobalNav();
    const areProfileAndHelpHidden = sessionService.areProfileAndHelpHidden();
    const isOrgEnabled = sessionService.isOrgUiEnabled() && !sessionService.hideOrgSwitcherUi();
    const openQueryBuilder = () => {
        navService.goToAnswer();
    };
    const openLiveboardListPage = () => {
        navService.goToHomeLiveboards();
    };
    const openAnswerListPage = () => {
        navService.goToHomeAnswers();
    };
    const getCurrentPathByLocationHash = (includeQueryParams) => {
        return navService.getCurrentPathByLocationHash(includeQueryParams);
    };
    const logo = customStylingService
        .getConfig()
        ?.getAppLogoUrl(AppLogoType.DEFAULT, AppLogoDefault);
    const navBackground = customStylingService.getConfig()?.getAppPanelColor()
        .color;
    const navBackgroundRef = useRef(null);
    useLayoutEffect(() => {
        if (navBackgroundRef.current) {
            navBackgroundRef.current.style.setProperty('background-color', `var(--ts-var-nav-background, ${navBackground})`, 'important');
        }
    }, [navBackgroundRef.current]);
    const HomeButtonContent = React.useMemo(() => {
        const clickHandler = () => {
            handleClick(homeButtonConfig, false, getCurrentPathByLocationHash, sessionService.isReactshellEnabled());
            metricsService.collectEvent(new UserAction(userActionTypeEnum.TOP_NAV_LOGO_CLICK), {
                isDefaultLogo: true,
            });
        };
        const homeHref = `#${homeButtonConfig.target.routerURI ??
            homeButtonConfig.target.uri}` || '/';
        return (React.createElement(RoutedLink, { href: homeHref, onClick: clickHandler, noUderline: true, tabIndex: 0, onKeyDown: getOnEnter(clickHandler), "aria-label": t('Thoughtspot.home'), "data-testid": TopNavTestIDs.HomeLink, color: "black" },
            React.createElement(Horizontal, { className: styles.homeLink, vAlignContent: "center", basis: "224px" },
                React.createElement(Image, { className: styles.tsLogo, src: logo }))));
    }, [homeButtonConfig]);
    const sendMixpanelEvent = (name) => {
        metricsService.collectEvent(new UserAction(userActionTypeEnum.TOP_NAV_APPLICATION_SWITCHER), {
            newApplication: name,
        });
    };
    return (React.createElement("div", { className: styles.topNav, role: "banner", ref: navBackgroundRef, id: "application-header" },
        HomeButtonContent,
        React.createElement(Horizontal, { grow: true, hAlignContent: "right", className: styles.searchBarWrapper }, !sessionService.isObjectSearchHidden() && searchBar),
        React.createElement(Horizontal, { spacing: "c", grow: 0, shrink: 0, hAlignContent: "right" },
            !sessionService.isApplicationSwitcherHidden() &&
                applicationSwitcherConfig?.length && (React.createElement(ApplicationSwitcher, { configs: applicationSwitcherConfig, activeApplicationID: activeApplicationID, sendMixpanelEvent: sendMixpanelEvent, openQueryBuilder: openQueryBuilder, openAnswerListPage: openAnswerListPage, openLiveboardListPage: openLiveboardListPage, getCurrentPathByLocationHash: getCurrentPathByLocationHash, isReactShellEnabled: sessionService.isReactshellEnabled(), disableQuickLinks: disableQuickLinks, customQuickLinks: customQuickLinks })),
            !areProfileAndHelpHidden && (React.createElement(HelpMenuContainer, { isPendoHelpEnabled: shouldShowPendoHelp, learningModule: learningModule })),
            !isOrgEnabled ? (userProfile && !areProfileAndHelpHidden && userProfile) : (React.createElement(Horizontal, { spacing: "a", grow: 0, shrink: 0, hAlignContent: "right", className: styles.orgAndUserProfileContainer },
                React.createElement(OrgMenuContainer, { isEmbedded: isEmbedded, invalidateSessionInfoCallCache: invalidateSessionInfoCallCache }),
                userProfile && !areProfileAndHelpHidden && userProfile)))));
};
//# sourceMappingURL=top-nav.container.js.map